import config from '../../config/config';

export const REPORTING_TRANSACTIONS_LOAD = 'REPORTING/TRANSACTIONS_LOAD';
export const REPORTING_TRANSACTIONS_FAILURE = 'REPORTING/TRANSACTIONS_FAILURE';
export const REPORTING_TRANSACTIONS_SUCCESS = 'REPORTING/TRANSACTIONS_SUCCESS';

export function getTransactionsReportSuccessActionCreator(results = {}) {
    return {
        transactions: results,
        type: REPORTING_TRANSACTIONS_SUCCESS
    };
}

export function getTransactionsReportFailureActionCreator(error) {
    return {
        error,
        type: REPORTING_TRANSACTIONS_FAILURE
    };
}

export function getTransactionsReport(merchantIds, startingDate = '', endingDate = '', currencyId) {
    const startDate = startingDate ? `?startDate=${startingDate.format()}` : '';
    const endDate = endingDate ? `&endDate=${endingDate.format()}` : '';
    const merchantIdsQuery = merchantIds ? `&merchantIds=${merchantIds}` : '';

    let url;

    const isResellerCall = !!currencyId;
    if (isResellerCall) {
        url = `${config.transactionsApiUrl}/reseller/transactionsSummary${startDate}${endDate}&transactionType=10&transactionStatus=${encodeURIComponent('10,20,31')}&currencyId=${currencyId}`;
    } else {
        url = `${config.transactionsApiUrl}/transactionsSummary${startDate}${endDate}${merchantIdsQuery}&transactionType=10&transactionStatus=${encodeURIComponent('10,20,31')}`;
    }

    return {
        failureActionTypeOrCreator: getTransactionsReportFailureActionCreator,
        fetchParams: {
            url
        },
        loadActionTypeOrCreator: REPORTING_TRANSACTIONS_LOAD,
        successActionTypeOrCreator: getTransactionsReportSuccessActionCreator
    };
}
